export default __webpack_public_path__ + "images/pages/quiz/categories/desktop_tech-c838b752a8b5eaf01498c71aee09f3be.svg";